var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.3093,
    r: 14,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.3093,
    r: 13.5,
    stroke: "black",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6068 7.5358C11.0159 7.5358 8.12695 10.4248 8.12695 14.0157C8.12695 16.8776 9.98992 19.3076 12.5549 20.1716C12.8789 20.2256 12.9869 20.0366 12.9869 19.8476C12.9869 19.6856 12.9869 19.2806 12.9869 18.7406C11.1779 19.1456 10.7999 17.8766 10.7999 17.8766C10.5029 17.1206 10.0709 16.9316 10.0709 16.9316C9.47693 16.5267 10.1249 16.5267 10.1249 16.5267C10.7729 16.5807 11.1239 17.2016 11.1239 17.2016C11.6909 18.2006 12.6359 17.9036 13.0139 17.7416C13.0679 17.3096 13.2299 17.0396 13.4189 16.8776C11.9879 16.7157 10.4759 16.1487 10.4759 13.6647C10.4759 12.9627 10.7189 12.3687 11.1509 11.9367C11.0969 11.7747 10.8539 11.1267 11.2049 10.2088C11.2049 10.2088 11.7449 10.0468 12.9869 10.8837C13.4999 10.7487 14.0669 10.6677 14.6068 10.6677C15.1468 10.6677 15.7138 10.7487 16.2268 10.8837C17.4688 10.0468 18.0088 10.2088 18.0088 10.2088C18.3598 11.0997 18.1438 11.7477 18.0628 11.9367C18.4678 12.3957 18.7378 12.9627 18.7378 13.6647C18.7378 16.1487 17.2258 16.6886 15.7678 16.8506C16.0108 17.0396 16.1998 17.4446 16.1998 18.0386C16.1998 18.9026 16.1998 19.6046 16.1998 19.8206C16.1998 19.9826 16.3078 20.1986 16.6588 20.1446C19.2238 19.3076 21.0867 16.8776 21.0867 14.0157C21.0867 10.4248 18.1978 7.5358 14.6068 7.5358Z",
    fill: "#2C444E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubicon);
export default __webpack_public_path__ + "static/media/githubicon.0c78aea27accd1686df1f72fc775b2f1.svg";
export { ForwardRef as ReactComponent };